export const sanitizeValue = (value, limit, isFullTrim = false) => {
  const trimmedValue = isFullTrim ? value.trim() : value.trimStart();

  return trimmedValue.substring(0, limit);
};

export const removeNonHexCharacters = (value = '') =>
  value.replace(/[^0-9A-F]+/gi, '');
